import { ActionType } from "../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../react-core/Flux/BaseStore";
import { ReRegTransferDispatcher } from "./Variable";

export interface ReRegTransferStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: number;
    
}

export class ReRegTransferStoreStatic extends BaseStore<ReRegTransferStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(ReRegTransferDispatcher, (actionData) =>
            this.onSelectedInvestmentStoreResponse(actionData)
        );
    }

    public getLastResult(): ReRegTransferStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

   
    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): ReRegTransferStoreStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }

    private onSelectedInvestmentStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: ActionType.Update, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
